export type Endpoints = {
  verifyEligibility: string;
  createManifest: string;
  getConfirmation: string;
  updateEmails: string;
};

export enum Environments {
  dev1 = 'dev1',
  dev2 = 'dev2',
  dev = 'dev',
  qa1 = 'qa1',
  qa2 = 'qa2',
  qa = 'qa',
  uat1 = 'uat1',
  uat2 = 'uat2',
  uat = 'uat',
  prod = 'prod',
}

const endpointPath = {
  verifyEligibility: '/verify',
  createManifest: '/manifest',
  getConfirmation: '/confirmation',
  updateEmails: '/email',
};

export const getEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev;
  } else {
    if (hostname.startsWith('appdev') || hostname.startsWith('app.dev.')) {
      return Environments.dev;
    } else if (hostname.startsWith('appqa') || hostname.startsWith('app.qa.')) {
      return Environments.qa;
    } else if (hostname.startsWith('appuat') || hostname.startsWith('app.uat.')) {
      return Environments.uat;
    } else if (hostname.startsWith('app.ace.')) {
      return Environments.prod;
    } else {
      return Environments.dev;
    }
  }
};

export const getApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `common.api.ace.aaa.com`;
  } else {
    return `common.api.${env}.ace.aaa.com`;
  }
};

export const getEndpoints = (hostname: string): Endpoints => {
  const env = getEnvironmentFromHost(hostname);
  const rootPath = '/payments-membership-pwol/membership-pwol/v1';
  const _endpoints: Endpoints = {
    verifyEligibility: `https://${getApiDomain(env)}${rootPath}${endpointPath.verifyEligibility}`,
    createManifest: `https://${getApiDomain(env)}${rootPath}${endpointPath.createManifest}`,
    getConfirmation: `https://${getApiDomain(env)}${rootPath}${endpointPath.getConfirmation}`,
    updateEmails: `https://${getApiDomain(env)}${rootPath}${endpointPath.updateEmails}`,
  };
  return _endpoints;
};

export const endpoints = getEndpoints(window.location.hostname);
